import script from "./UploadFeedbackModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFeedbackModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadFeedbackModal.vue?vue&type=style&index=0&id=7ada0e50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ada0e50"]])

export default __exports__